import { CorePermissions } from '@/constants/permissions.constant';
import { AllValues } from '@/utils/types/types.util';
import { PermissionKeyEnum } from '@/utils/types/Permission';

export function savePermissionsToStorage(
  permissionKey: PermissionKeyEnum,
  permissions: AllValues<typeof CorePermissions>[],
) {
  localStorage.setItem(permissionKey, JSON.stringify(permissions));
}

type CorePermissionValue = AllValues<typeof CorePermissions>;

export function loadCorePermissionsFromStorage(): CorePermissionValue[] {
  const storageValue = localStorage.getItem(PermissionKeyEnum.Core);
  if (!storageValue) {
    return [CorePermissions.Tiles.FullRead];
  }

  try {
    return JSON.parse(storageValue);
  } catch (_error) {
    return [];
  }
}
